import {
  List as ImmutableList,
  Record as ImRecord,
  type RecordOf,
  type Map as ImmutableMap,
} from 'immutable';
import type { DurationUnit, Interval, DateTime } from 'luxon';

import type { CashFlowTransaction } from 'companion-app-components/flux/transactions/transactionsTypes';
import type { Category } from 'companion-app-components/flux/categories/categoriesTypes';

export type FrequencyData = {
  frequency: DurationUnit;
  duration: string;
  keyFromPeriod: (period: DateTime) => string;
  shortLabelFromPeriod: (period: DateTime) => string;
  labelFromPeriod: (period: DateTime) => string;
  yearFromPeriod: (period: DateTime) => string;
};

export type OTReturnProps = {
  periods: ImmutableList<Record<string, any>>;
  txns: ImmutableList<CashFlowTransaction>;
  currency: string;
};

export type OTReturnRecord = RecordOf<OTReturnProps>;

export const OTReturn = ImRecord<OTReturnProps>({
  periods: ImmutableList(),
  txns: ImmutableList(),
  currency: '',
});

export type OtReportProps = {
  accountIds?: any;
  dateInterval: Interval;
  frequency: string;
  filterCriteria?: Record<string, any>;
  filterBySource?: string | null;
};

export type FilterFns = {
  isTxnCandidateForReporting: (txn: CashFlowTransaction, dateInterval: Interval) => boolean;
  isTxnItemReportable: (item: any, categoriesById: ImmutableMap<string, Category>) => boolean;
};
